import React, { Fragment } from "react"
import { MdClose } from "react-icons/md"
import { useTranslation } from "react-i18next"


import { moment, scale } from "utils"
import PlSeparator from "./PlSeparator"
import { productUnitsSymbol } from "constant"

const PlOrderEditedPrintTemplate = (props) => {
  const { templateType, printData, forPos, printerWidth } = props

  const {
    date,
    code,
    kitchenTitle,
    serviceTypeName,
    items,
    tableNumber
  } = printData

  const [t] = useTranslation()

  const styles =
    templateType === "thermal" ? stylesThermal(printerWidth) : stylesOthers

  const showTableNumber =
    !!tableNumber &&
    serviceTypeName === "restaurant"

  return (
    <Fragment>
      <div style={styles["container"]}>
        <div style={styles["title"]}>
          (ویرایش سفارش)
        </div>

        <div style={styles["headerTable"]}>
          <div style={styles["row"]}>
            <div style={styles["cell1"]}>
              <div style={styles["center"]}>
                {moment(date).format("HH:mm")}
              </div>
              <div style={styles["center"]}>
                {moment(date).format("jYYYY/jMM/jDD")}
              </div>
            </div>
            <div style={styles["cell2"]}>
              <div style={styles["center"]}>
                {kitchenTitle}
              </div>
            </div>
            <div style={styles["cell1"]}>
              <div style={styles["center"]}>
                شماره فاکتور
              </div>
            </div>
          </div>

          <div style={styles["row"]}>
            <div style={styles["cell3"]}>
              {
                showTableNumber &&
                <div style={styles["text"]}>
                  میز: {String(tableNumber)}
                </div>
              }
            </div>
            <div style={styles["cell5"]}>
              <div style={styles["center"]}>
                {code}
              </div>
            </div>
          </div>
        </div>

        <div style={styles["text2"]}>
          توضیحات:
        </div>

        <div style={styles["tableContainer"]}>
          <div style={styles["table"]}>
            <div style={styles["row"]}>
              <div style={styles["th_name"]}>
                <div style={styles["thText"]}>
                  نام کالا
                </div>
              </div>
              <div style={styles["th_qty"]}>
                <div style={styles["thText"]}>
                  واحد
                </div>
              </div>
            </div>
          </div>
        </div>

        {items.map((item, itemIndex) =>
          <div key={itemIndex} style={styles["row"]}>
            <div style={styles["td_name"]}>
              <div style={styles["tdText"]}>
                {item.foodName}
              </div>
              {
                !item.isSimple &&
                <div style={styles["optionName"]}>
                  {item.option.name}{t(productUnitsSymbol[item.unit])}
                </div>
              }
              {item.orderItemSpecifications.map((specificationItem, siIndex) =>
                <div key={siIndex} style={styles["specificationItem"]}>
                  {specificationItem.name}
                  <MdClose />
                  {specificationItem.quantity * item.quantity}
                </div>
              )}
            </div>
            <div style={styles["td_qty"]}>
              <div style={styles["tdTextNumber"]}>
                {item.quantity}
              </div>
            </div>
          </div>
        )}
      </div>

      <PlSeparator
        forPos={forPos}
        templateType={templateType}
      />
    </Fragment>
  )
}

const stylesThermal = (printerWidth) => ({
  container: {
    fontSize: scale("19px", printerWidth),
  },

  headerTable: {

  },
  row: {
    display: "flex",
    flexDirection: "row"
  },

  text: {

  },

  center: {
    textAlign: "center"
  },

  cell1: {
    flex: 1,
    border: `${scale("2px")} solid`,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  },

  cell2: {
    flex: 2,
    borderBottom: `${scale("2px")} solid`,
    borderTop: `${scale("2px")} solid`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },

  cell3: {
    flex: 3,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    paddingLeft: scale("4px"),
    borderBottom: `${scale("2px")} solid`,
    borderRight: `${scale("2px")} solid`
  },

  cell5: {
    flex: 1,
    borderLeft: `${scale("2px")} solid`,
    borderBottom: `${scale("2px")} solid`,
    borderRight: `${scale("2px")} solid`,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  },

  text1: {
    width: "100%",

  },

  title: {

    textAlign: "center",
    marginBottom: scale("10px")
  },

  text2: {
    fontWeight: "bold",

    marginTop: scale("18px"),
    marginBottom: scale("12px")
  },

  tableContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },

  table: {
    width: "100%",
    border: `${scale("2px")} solid`,
    marginTop: scale("15px")
  },

  th_name: {
    flex: 1.5,
    padding: scale("1px"),
    color: "white",
    backgroundColor: "black"
  },

  th_qty: {
    flex: 0.4,
    padding: scale("1px"),
    color: "white",
    backgroundColor: "black",
  },

  th_price: {
    flex: 1,
    padding: scale("1px"),
    color: "white",
    backgroundColor: "black",
  },

  td_name: {
    flex: 1.5,
    padding: scale("1px"),
    border: `${scale("2px")} solid`,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start"
  },
  td_qty: {
    flex: 0.4,
    padding: scale("1px"),
    border: `${scale("2px")} solid`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  thText: {
    fontWeight: "bold",
    textAlign: "center",

  },

  tdText: {

  },

  optionName: {

  },

  specificationItem: {

  },

  tdTextNumber: {

  }
})

const stylesOthers = {
  container: {
    marginRight: "8px",
    fontSize: "11px"
  },

  headerTable: {
    border: "1px solid",
  },

  row: {
    display: "flex",
    flexDirection: "row",
  },

  center: {
    textAlign: "center"
  },

  cell1: {
    flex: 1,
    border: "1px solid",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  },

  cell5: {
    flex: 1,
    borderLeft: "1px solid",
    borderBottom: "1px solid",
    borderRight: "1px solid",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  },

  cell2: {
    flex: 2,
    border: "1px solid",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  cell3: {
    flex: 3,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    paddingLeft: "4px"
  },

  text1: {
    width: "100%"
  },

  title: {
    fontSize: "15px",
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: "10px",
  },

  text2: {
    fontWeight: "bold",
    marginTop: "10px",
    marginBottom: "10px"
  },

  tableContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },

  table: {
    width: "100%",
    border: "1px solid",
    marginTop: "10px"
  },

  th_name: {
    flex: 1.5,
    padding: "1px",
    color: "white",
    backgroundColor: "black"
  },

  th_qty: {
    flex: 0.4,
    padding: "1px",
    color: "white",
    backgroundColor: "black"
  },

  th_price: {
    flex: 1,
    padding: "1px",
    color: "white",
    backgroundColor: "black"
  },

  td_name: {
    flex: 1.5,
    padding: "1px",
    border: "1px solid",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start"
  },

  td_qty: {
    flex: 0.4,
    padding: "1px",
    border: "1px solid",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  thText: {
    fontWeight: "bold",
    textAlign: "center"
  }
}

export default PlOrderEditedPrintTemplate